/*!

=========================================================
* Vision UI Free React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-free-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)
* Licensed under MIT (https://github.com/creativetimofficial/vision-ui-free-react/blob/master LICENSE.md)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// @mui material components
import Card from "@mui/material/Card";

// Vision UI Dashboard React components
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import VuiBox from "components/VuiBox";
import VuiInput from "components/VuiInput";
import VuiTypography from "components/VuiTypography";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import VuiButton from "components/VuiButton";
import { Link } from 'react-router-dom';
import VuiSwitch from "components/VuiSwitch";

// Vision UI Dashboard React example components
import LineChart from "examples/Charts/LineCharts/LineChart2";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Table from "examples/Tables/Table";

import React, { useEffect, useState, useCallback } from "react"
import imgTrans from "assets/images/trans.png";
import imgTemple from "assets/images/temple2.png";
import imgD6 from "assets/images/d6.png";
import imgD5 from "assets/images/d5.png";
import imgD4 from "assets/images/d4.png";
import imgD3 from "assets/images/d3.png";
import imgD2 from "assets/images/d2.png";
import imgD1 from "assets/images/d1.png";
import imgT5 from "assets/images/t5.png";
import imgT4 from "assets/images/t4.png";
import imgT3 from "assets/images/t3.png";
import imgT2 from "assets/images/t2.png";
import imgT1 from "assets/images/t1.png";
import imgV4 from "assets/images/v4.png";
import imgV3 from "assets/images/v3.png";
import imgV2 from "assets/images/v2.png";
import imgV1 from "assets/images/v1.png";
import imgATier from "assets/images/ATier.png";
import imgSTier from "assets/images/STier.png";
import imgStellar from "assets/images/stellar.png";

import { useHistory, useLocation } from 'react-router-dom';
import { getUser } from 'discordAPI'
import { getAPIToken, getGuilds, getMember, updateMember, updateMemberGuild, createMember } from 'GaiaAPI'
import { getDetailsFromHistoryCode, getDetailsFromHistoryCodeForGuild, getValueFromString, calculateSS } from 'Utils'


function Member() {
    const history = useHistory();
    const location = useLocation();
    var allGuilds;
    const [guilds, setGuilds] = useState([]);
    const [guildNames, setGuildNames] = useState([]);
    const [user, setUser] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [isDisabled, setIsDisabled] = useState(true);
    const [saveMessage, setSaveMessage] = useState([]);
    const [saveMessageColor, setSaveMessageColor] = useState([]);
    
    
    const [leaderCheck, setLeaderCheck] = useState(false);
    const handleLeaderCheck = () => { setLeaderCheck(!leaderCheck); setSaveDisabled(false); }
    const [officerCheck, setOfficerCheck] = useState(false);
    const handleOfficerCheck = () => { setOfficerCheck(!officerCheck); setSaveDisabled(false); }
    const [altCheck, setAltCheck] = useState(false);
    const handleAltCheck = () => { setAltCheck(!altCheck); setSaveDisabled(false); }
    const [inactiveCheck, setInactiveCheck] = useState(false);
    const handleInactiveCheck = () => { setInactiveCheck(!inactiveCheck); setSaveDisabled(false); }

    const [selectedItems, setSelectedItems] = useState([]);
    const [lineChartData, setLineChartData] = useState([]);
    const [lineChartOptions, setLineChartOptions] = useState([]);
    const [resultColumns, setResultColumns] = useState([]);
    const [resultRows, setResultRows] = useState([]);
    var columnList;
    const [resultColumnsList, setResultColumnsList] = useState([]);

    
    const [historyColumns, setHistoryColumns] = useState([]);
    const [historyRows, setHistoryRows] = useState([]);

    const [member, setMember] = useState([]);
    // user fields
    const [newMember, setNewMember] = useState(false);
    const [memberName, setMemberName] = useState([]);
    const [guildName, setGuildName] = useState([]);
    const [guildColour, setGuildColour] = useState([]);
    const [serverNumber, setServerNumber] = useState([]);
    const [userId, setUserId] = useState([]);
    const [discord, setDiscord] = useState([]);
    const [comments, setComments] = useState([]);
    const [power, setPower] = useState([]);
    const [previousPower, setPreviousPower] = useState([]);
    const [powerChange, setPowerChange] = useState([]);
    const [pwrColor, setPwrColor] = useState([]);
    
    const [ccl, setCCL] = useState([]);
    const [trans, setTrans] = useState([]);
    const [stier, setSTier] = useState([]);
    const [atier, setATier] = useState([]);
    const [temple, setTemple] = useState([]);
    const [heroesD6, setHeroesD6] = useState([]);
    const [heroesD5, setHeroesD5] = useState([]);
    const [heroesD4, setHeroesD4] = useState([]);
    const [heroesD3, setHeroesD3] = useState([]);
    const [heroesD2, setHeroesD2] = useState([]);
    const [heroesD1, setHeroesD1] = useState([]);
    const [heroesT5, setHeroesT5] = useState([]);
    const [heroesT4, setHeroesT4] = useState([]);
    const [heroesT3, setHeroesT3] = useState([]);
    const [heroesT2, setHeroesT2] = useState([]);
    const [heroesT1, setHeroesT1] = useState([]);
    const [heroesV4, setHeroesV4] = useState([]);
    const [heroesV3, setHeroesV3] = useState([]);
    const [heroesV2, setHeroesV2] = useState([]);
    const [heroesV1, setHeroesV1] = useState([]);
    const [seScore, setSeScore] = useState([]);
    const [seScoreEasy, setSeScoreEasy] = useState([]);
    const [seHard, setSeHard] = useState([]);
    const [totalSS, setTotalSS] = useState([]);
    const [extraSS, setExtraSS] = useState([]);
    const [heroesD6Value, setHeroesD6Value] = useState([]);
    const [heroesD5Value, setHeroesD5Value] = useState([]);
    const [heroesD4Value, setHeroesD4Value] = useState([]);
    const [heroesD3Value, setHeroesD3Value] = useState([]);
    const [heroesD2Value, setHeroesD2Value] = useState([]);
    const [heroesD1Value, setHeroesD1Value] = useState([]);

    const updateMemberName = (newVal) => { setMemberName(newVal); setSaveDisabled(false); };
    const updateServer = (newVal) => { setServerNumber(newVal); setSaveDisabled(false); };
    const updateUserId = (newVal) => { setUserId(newVal); setSaveDisabled(false); };
    const updateDiscord = (newVal) => { setDiscord(newVal); setSaveDisabled(false); };
    const updateComments = (newVal) => { setComments(newVal); setSaveDisabled(false); };
    const updatePower = (newVal) => { setPower(newVal); setSaveDisabled(false); };
    const updateCCL = (newVal) => { setCCL(newVal); setSaveDisabled(false); };
    const updateTrans = (newVal) => { setTrans(newVal); setSaveDisabled(false); };
    const updateSTier = (newVal) => { setSTier(newVal); setSaveDisabled(false); };
    const updateATier = (newVal) => { setATier(newVal); setSaveDisabled(false); };
    const updateTemple = (newVal) => { setTemple(newVal); setSaveDisabled(false); setDestinyValue(newVal); };
    const updateHeroesD6 = (newVal) => { setHeroesD6(newVal); setSaveDisabled(false); };
    const updateHeroesD5 = (newVal) => { setHeroesD5(newVal); setSaveDisabled(false); };
    const updateHeroesD4 = (newVal) => { setHeroesD4(newVal); setSaveDisabled(false); };
    const updateHeroesD3 = (newVal) => { setHeroesD3(newVal); setSaveDisabled(false); };
    const updateHeroesD2 = (newVal) => { setHeroesD2(newVal); setSaveDisabled(false); };
    const updateHeroesD1 = (newVal) => { setHeroesD1(newVal); setSaveDisabled(false); };
    const updateHeroesT5 = (newVal) => { setHeroesT5(newVal); setSaveDisabled(false); };
    const updateHeroesT4 = (newVal) => { setHeroesT4(newVal); setSaveDisabled(false); };
    const updateHeroesT3 = (newVal) => { setHeroesT3(newVal); setSaveDisabled(false); };
    const updateHeroesT2 = (newVal) => { setHeroesT2(newVal); setSaveDisabled(false); };
    const updateHeroesT1 = (newVal) => { setHeroesT1(newVal); setSaveDisabled(false); };
    const updateHeroesV4 = (newVal) => { setHeroesV4(newVal); setSaveDisabled(false); };
    const updateHeroesV3 = (newVal) => { setHeroesV3(newVal); setSaveDisabled(false); };
    const updateHeroesV2 = (newVal) => { setHeroesV2(newVal); setSaveDisabled(false); };
    const updateHeroesV1 = (newVal) => { setHeroesV1(newVal); setSaveDisabled(false); };
    const updateSeScore = (newVal) => { setSeScore(newVal); setSaveDisabled(false); };
    const updateSeScoreEasy = (newVal) => { setSeScoreEasy(newVal); setSaveDisabled(false); };
    const updateExtraSS = (newVal) => { setExtraSS(newVal); setSaveDisabled(false); };

    const [saveDisabled, setSaveDisabled] = useState(null);

    const [menu, setMenu] = useState(null);
    const [menuGuild, setMenuGuild] = useState(null);
    const [sortMode, setSortMode] = useState(['Power']);

    const openMenuGuild = ({ currentTarget }) => setMenuGuild(currentTarget);
    const closeMenuGuild = () => setMenuGuild(null);

    const renderMenuGuild = (
        <Menu
            id="simple-menu"
            anchorEl={menuGuild}
            anchorOrigin={{
                vertical: "top",
                horizontal: "left",
            }}
            transformOrigin={{
                vertical: "top",
                horizontal: "right",
            }}
            open={Boolean(menuGuild)}
            onClose={closeMenuGuild}
        >
            {
                guildNames.map((guildName) => (
                    <MenuItem onClick={() => selectGuild(guildName)}>{guildName}</MenuItem>
                ))
            }
        </Menu>
    );

    const selectGuild = (guild) => {
        setGuildDetails(guilds, guild);
        setSaveDisabled(false);
        let mySelection = selectedItems;
        let myGuild = guilds.find(g => g.name === guild);
        if (myGuild && selectedItems.length > 1) {
            mySelection.pop();
            mySelection.push(myGuild);
            setSelectedItems(mySelection);

            let months = [];
            let colours = [];

            // user colour
            colours.push("#0075FF");
            colours.push('#' + myGuild.colour);

            for (let i2 = myGuild.historyDates.length - 1; i2 >= 0; i2--) {
                months.push(myGuild.historyDates[i2]);
            }
            months.push('Now');


            setChartOptions(months, colours);
        }
        refreshChart(mySelection, sortMode);
        setMenuGuild(null)
    };

    const openMenu = ({ currentTarget }) => setMenu(currentTarget);
    const closeMenu = () => setMenu(null);
    const sortbyPower = () => {
        let newSortMode = 'Power'
        setSortMode(newSortMode);
        refreshChart(selectedItems, newSortMode);
        setMenu(null)
    };
    const sortbySE = () => {
        let newSortMode = 'Star Expedition'
        setSortMode(newSortMode);
        refreshChart(selectedItems, newSortMode);
        setMenu(null)
    };
    const sortbyCCL = () => {
        let newSortMode = 'CCL'
        setSortMode(newSortMode);
        refreshChart(selectedItems, newSortMode);
        setMenu(null)
    };

    const renderMenu = (
        <Menu
            id="simple-menu"
            anchorEl={menu}
            anchorOrigin={{
                vertical: "top",
                horizontal: "left",
            }}
            transformOrigin={{
                vertical: "top",
                horizontal: "right",
            }}
            open={Boolean(menu)}
            onClose={closeMenu}
        >
            <MenuItem onClick={sortbyPower}>Power</MenuItem>
            <MenuItem onClick={sortbySE}>Star Expedition</MenuItem>
            <MenuItem onClick={sortbyCCL}>CCL</MenuItem>
        </Menu>
    );
    
    function setDestinyValue(templeVal) {
        let templeInt = Number(templeVal);
        
        let extraDestinyValues = [0,0,0,1,2,3,4,4,5,5,6,6,7,7,8,8,9];

        let extraDestiny = 0;
        
        if (templeInt && templeInt > 0 && templeInt < extraDestinyValues.length)
            extraDestiny = extraDestinyValues[templeInt];

        setHeroesD6Value(extraDestiny + 6);
        setHeroesD5Value(extraDestiny + 5);
        setHeroesD4Value(extraDestiny + 4);
        setHeroesD3Value(extraDestiny + 3);
        setHeroesD2Value(extraDestiny + 2);
        setHeroesD1Value(extraDestiny + 1);
    }

    function CheckChangeGuild(token, updaterDiscord) {
        return new Promise((resolve, reject) => {
            try {
                if (member.guild != guildName) {
                    updateMemberGuild(token, member.guild, member.name, guildName, updaterDiscord)
                        .then(() => {
                            resolve(true);
                        },
                        (err) => {
                            reject(err);
                        });
                }
                else
                    resolve(true);
            } catch (err) {
                reject(err);
            }
        });
    }

    function validateMember() {
        let error = null;
        if (!memberName || memberName.length < 0) {
            error = 'Name is a required field';
        }
        if (!guildName || guildName.length < 0) {
            error = 'Guild is a required field';
        }

        if (error) {
            setSaveMessageColor("error");
            setSaveMessage(error);
            return false;
        }
        else
            return true;
    }

    const handleSaveClick = () => {

        setSaveMessage('');
        if (validateMember() === false)
            return;

        let updaterDiscord = user.username + ' (' + user.name + ') - Web';

        getAPIToken()
            .then((token) => {
                CheckChangeGuild(token, updaterDiscord)
                .then(() => {
                    let myMember = member;

                    myMember.name = memberName;
                    myMember.guild = guildName;
                    myMember.server = serverNumber;
                    myMember.userId = userId;
                    myMember.discord = discord;
                    myMember.comments = comments;
                    myMember.power = power;
                    myMember.ccl = ccl;
                    myMember.trans = trans;
                    myMember.stier = stier;
                    myMember.atier = atier;
                    myMember.temple = temple;
                    myMember.d6 = heroesD6;
                    myMember.d5 = heroesD5;
                    myMember.d4 = heroesD4;
                    myMember.d3 = heroesD3;
                    myMember.d2 = heroesD2;
                    myMember.d1 = heroesD1;
                    myMember.t5 = heroesT5;
                    myMember.t4 = heroesT4;
                    myMember.t3 = heroesT3;
                    myMember.t2 = heroesT2;
                    myMember.t1 = heroesT1;
                    myMember.v4 = heroesV4;
                    myMember.v3 = heroesV3;
                    myMember.v2 = heroesV2;
                    myMember.v1 = heroesV1;
                    myMember.se = seScore;
                    myMember.seeasy = seScoreEasy;
                    myMember.extraSS = extraSS;
                    
                    let position = '';
                    if (leaderCheck)
                        position = position + 'L';
                    if (officerCheck)
                        position = position + 'O';
                    if (altCheck)
                        position = position + 'A';
                    if (inactiveCheck)
                        position = position + 'I';

                    myMember.position = position;

                    try {
                        if (newMember) {
                            createMember(token, myMember, updaterDiscord)
                                .then(() => {
                                    setSaveMessage('Save Complete');
                                    setSaveMessageColor("success");
                                    setSaveDisabled(true);
                                    setNewMember(false);
                                    localStorage.removeItem("guildsUpdateDate");
                                },
                                    (err) => {
                                        setSaveMessage(err.response.data);
                                        setSaveMessageColor("error");
                                    });
                        }
                        else {
                            updateMember(token, myMember, updaterDiscord)
                                .then(() => {
                                    setSaveMessage('Save Complete');
                                    setSaveMessageColor("success");
                                    setSaveDisabled(true);
                                    localStorage.removeItem("guildsUpdateDate");
                                },
                                    (err) => {
                                        setSaveMessage(err.response.data);
                                        setSaveMessageColor("error");
                                    });
                        }
                    } catch (err) {
                        setSaveMessage(err.response.data);
                        setSaveMessageColor("error");
                    }
                },
                (err) => {
                    setSaveMessage(err.toString());
                    setSaveMessageColor("error");
                });
        },
        (err) => {
            alert(err);
            setSaveMessage(err.toString());
            setSaveMessageColor("error");
        });
    };

    function getValueFromHistory(history, currentSortMode, isGuild) {
        let result = null;
        var historyCode;

        if (isGuild)
            historyCode = getDetailsFromHistoryCodeForGuild(history);
        else
            historyCode = getDetailsFromHistoryCode(history);

        if (historyCode) {
            if (currentSortMode ==='Star Expedition')
                result = getValueFromString(historyCode.se);
            else if (currentSortMode ==='CCL')
                result = getValueFromString(historyCode.ccl);
            else if (currentSortMode ==='Guild') {
                return historyCode.guild;
            }
            else {
                result = getValueFromString(historyCode.power);
                if (result && isGuild)
                    result = result * 1000;
            }

            if (isGuild && result && (currentSortMode !=='CCL')) {
                result = result / 30;
            }

            if (result)
                result = result.toFixed(2);
        }

        return result;
    }

    function convertHexToRGBA(hex, opacity) {
        if (!hex)
            hex = '888888'
        const tempHex = hex.replace('#', '');
        const r = parseInt(tempHex.substring(0, 2), 16);
        const g = parseInt(tempHex.substring(2, 4), 16);
        const b = parseInt(tempHex.substring(4, 6), 16);

        return 'rgba(' + r + ',' + g + ',' + b + ',' + opacity + ')';
    };

    function setMemberHistoryGrid(allGuilds, curMember) {
        let rows = [];
        let columns = [];
        columns.push({ name: "date", align: "center" });
        columns.push({ name: "guild", align: "center" });
        columns.push({ name: "power", align: "center" });
        columns.push({ name: "powerdiff", align: "center" });
        columns.push({ name: "ccl", align: "center" });
        columns.push({ name: "ccldiff", align: "center" });
        columns.push({ name: "se", align: "center" });
        columns.push({ name: "sediff", align: "center" });

        if (curMember.historyDates) {
            for (let i = -1; i < curMember.historyDates.length; i++) {
                if (i === -1 || (curMember.history[i] && curMember.history[i] != '#####' && curMember.history[i] != '#####0'))
                {
                    let colour = "transparent";
                    let date = '';
                    let guildname = null;
                    let prevpower = null;
                    let power = null;
                    let powerdiff = null;
                    let ccl = null;
                    let prevccl = null;
                    let ccldiff = null;
                    let se = null;
                    let prevse = null;
                    let sediff = null;

                    if (i > -1) {
                        date = curMember.historyDates[i];
                        guildname = getValueFromHistory(curMember.history[i], 'Guild', false);
                        power = getValueFromHistory(curMember.history[i], 'Power', false);
                        ccl = getValueFromHistory(curMember.history[i], 'CCL', false);
                        se = getValueFromHistory(curMember.history[i], 'Star Expedition', false);
                    }
                    else {
                        date = 'Now';
                        guildname = curMember.guild;
                        power = curMember.power;
                        ccl = curMember.ccl;
                        se = curMember.se;
                    }
                    
                    prevpower = getValueFromHistory(curMember.history[i+1], 'Power', false);
                    prevccl = getValueFromHistory(curMember.history[i+1], 'CCL', false);
                    prevse = getValueFromHistory(curMember.history[i+1], 'Star Expedition', false);

                    if (power && prevpower) {         
                        let changePercent = convertStringToNumber(((power / prevpower) - 1) * 100, 1);
                        let changeInc = (power - prevpower);
                        if (changeInc) {
                            changeInc = changeInc.toFixed(1);
                            if (changeInc > 0) {
                                //setPwrColor('success');
                                changeInc = '+' + changeInc;
                            }
                            //else
                            //    setPwrColor('error');
                        }
                        changeInc = changeInc + ' (' + changePercent + '%)';
                        powerdiff = changeInc;
                    }

                    if (ccl && prevccl) {         
                        let changePercent = convertStringToNumber(((ccl / prevccl) - 1) * 100, 1);
                        let changeInc = (ccl - prevccl);
                        if (changeInc) {
                            changeInc = changeInc.toFixed(1);
                            if (changeInc > 0) {
                                changeInc = '+' + changeInc;
                            }
                        }
                        changeInc = changeInc + ' (' + changePercent + '%)';
                        ccldiff = changeInc;
                    }

                    if (se && prevse) {         
                        let changePercent = convertStringToNumber(((se / prevse) - 1) * 100, 1);
                        let changeInc = (se - prevse);
                        if (changeInc) {
                            changeInc = changeInc.toFixed(1);
                            if (changeInc > 0) {
                                changeInc = '+' + changeInc;
                            }
                        }
                        changeInc = changeInc + ' (' + changePercent + '%)';
                        sediff = changeInc;
                    }

                    
                    let guild = allGuilds.find(item => item.name === guildname);
                    if (guild && guild.colour) {
                        colour = convertHexToRGBA(guild.colour, 0.2);
                    }
                    
                    let row = {
                        date:
                            <VuiBox display="flex" alignItems="center" px={0.8} py={0.1}>
                                <VuiBox display="flex" flexDirection="column">
                                    <VuiTypography variant="button" color="white" fontWeight="medium">
                                        {date}
                                    </VuiTypography>
                                </VuiBox>
                            </VuiBox>,
                        guild:
                            <VuiBox display="flex" alignItems="center" bgColor={colour} sx={{ width: '100px', borderRadius: '12px' }}>
                                <VuiBox display="flex" alignItems="center" flexDirection="column">
                                    <VuiTypography pl="10px" variant="button" color="white" fontWeight="medium" >
                                        {guildname}
                                    </VuiTypography>
                                </VuiBox>
                            </VuiBox>,
                        power:
                            <VuiBox display="flex" alignItems="center" px={0.8} py={0.1}> <VuiTypography variant="button" color="white" fontWeight="medium"> {power} </VuiTypography></VuiBox>,
                        powerdiff:
                            <VuiBox display="flex" alignItems="center" px={0.8} py={0.1}> <VuiTypography variant="button" color="white" fontWeight="medium"> {powerdiff} </VuiTypography></VuiBox>,
                        ccl:
                            <VuiBox display="flex" alignItems="center" px={0.8} py={0.1}> <VuiTypography variant="button" color="white" fontWeight="medium"> {ccl} </VuiTypography></VuiBox>,
                        ccldiff:
                            <VuiBox display="flex" alignItems="center" px={0.8} py={0.1}> <VuiTypography variant="button" color="white" fontWeight="medium"> {ccldiff} </VuiTypography></VuiBox>,
                        se:
                            <VuiBox display="flex" alignItems="center" px={0.8} py={0.1}> <VuiTypography variant="button" color="white" fontWeight="medium"> {se} </VuiTypography></VuiBox>,
                        sediff:
                            <VuiBox display="flex" alignItems="center" px={0.8} py={0.1}> <VuiTypography variant="button" color="white" fontWeight="medium"> {sediff} </VuiTypography></VuiBox>
                    };

                    rows.push(row);
                }
            }
        }
        
        setHistoryColumns(columns);
        setHistoryRows(rows);
    }

    function refreshChart(mySelectedItems, currentSortMode) {
        try {
            let rows = [];
            let chartRows = [];
            let colours = [];


            let monthColumns = resultColumnsList;
            if (!monthColumns || monthColumns.length ===0)
                monthColumns = columnList;

            for (let i = 0; i < mySelectedItems.length; i++) {
                let values = [];
                let item = mySelectedItems[i]
                let colour = "transparent";
                let membername = null;
                let guildname = null;
                let isGuild = false;
                if (item.guild) {
                    // a member
                    guildname = item.guild;
                    membername = item.name;
                    let myGuilds = guilds;
                    if (!myGuilds || myGuilds.length ===0)
                        myGuilds = allGuilds;
                    let guild = myGuilds.find(item => item.name === guildname);
                    if (guild && guild.colour) {
                        colour = convertHexToRGBA(guild.colour, 0.2);
                        colours.push('#' + guild.colour);
                    }
                }
                else {
                    isGuild = true;
                    guildname = item.name;
                    colour = convertHexToRGBA(item.colour, 0.2);
                    colours.push('#' + item.colour);
                }
                if (item.history) {
                    values.push(getValueFromHistory(item.history[10], currentSortMode, isGuild));
                    values.push(getValueFromHistory(item.history[9], currentSortMode, isGuild));
                    values.push(getValueFromHistory(item.history[8], currentSortMode, isGuild));
                    values.push(getValueFromHistory(item.history[7], currentSortMode, isGuild));
                    values.push(getValueFromHistory(item.history[6], currentSortMode, isGuild));
                    values.push(getValueFromHistory(item.history[5], currentSortMode, isGuild));
                    values.push(getValueFromHistory(item.history[4], currentSortMode, isGuild));
                    values.push(getValueFromHistory(item.history[3], currentSortMode, isGuild));
                    values.push(getValueFromHistory(item.history[2], currentSortMode, isGuild));
                    values.push(getValueFromHistory(item.history[1], currentSortMode, isGuild));
                    values.push(getValueFromHistory(item.history[0], currentSortMode, isGuild));
                }

                if (currentSortMode ==='Star Expedition') {
                    let result = 0;
                    if (isGuild) {
                        result = getValueFromString(item.seScore);
                        if (result && isGuild)
                            result = result / 30;
                    }
                    else
                        result = getValueFromString(item.se);
                    if (!result)
                        result = 0;
                    values.push(result.toFixed(2));
                }
                else if (currentSortMode ==='CCL') {
                    let result = 0;
                    if (isGuild)
                        result = getValueFromString(item.avgCCL);
                    else
                        result = getValueFromString(item.ccl);
                    if (!result)
                        result = 0;
                    values.push(result.toFixed(2));
                }
                else {
                    let result = getValueFromString(item.power);
                    if (result && isGuild)
                        result = (result * 1000) / 30;
                    if (!result)
                        result = 0;
                    values.push(result.toFixed(2));
                }

                let row = {
                    name:
                        <VuiBox display="flex" alignItems="center" px={0.8} py={0.1}>
                            <VuiBox display="flex" flexDirection="column">
                                <VuiTypography variant="button" color="white" fontWeight="medium">
                                    {membername}
                                </VuiTypography>
                            </VuiBox>
                        </VuiBox>,
                    guild:
                        <VuiBox display="flex" alignItems="center" bgColor={colour} sx={{ width: '100px', borderRadius: '12px' }}>
                            <VuiBox display="flex" alignItems="center" flexDirection="column">
                                <VuiTypography pl="10px" variant="button" color="white" fontWeight="medium" >
                                    {guildname}
                                </VuiTypography>
                            </VuiBox>
                        </VuiBox>,
                    [monthColumns[0]]:
                        <VuiBox display="flex" alignItems="center" px={0.8} py={0.1}> <VuiTypography variant="button" color="white" fontWeight="medium"> {values[0]} </VuiTypography></VuiBox>,
                    [monthColumns[1]]:
                        <VuiBox display="flex" alignItems="center" px={0.8} py={0.1}> <VuiTypography variant="button" color="white" fontWeight="medium"> {values[1]} </VuiTypography></VuiBox>,
                    [monthColumns[2]]:
                        <VuiBox display="flex" alignItems="center" px={0.8} py={0.1}> <VuiTypography variant="button" color="white" fontWeight="medium"> {values[2]} </VuiTypography></VuiBox>,
                    [monthColumns[3]]:
                        <VuiBox display="flex" alignItems="center" px={0.8} py={0.1}> <VuiTypography variant="button" color="white" fontWeight="medium"> {values[3]} </VuiTypography></VuiBox>,
                    [monthColumns[4]]:
                        <VuiBox display="flex" alignItems="center" px={0.8} py={0.1}> <VuiTypography variant="button" color="white" fontWeight="medium"> {values[4]} </VuiTypography></VuiBox>,
                    [monthColumns[5]]:
                        <VuiBox display="flex" alignItems="center" px={0.8} py={0.1}> <VuiTypography variant="button" color="white" fontWeight="medium"> {values[5]} </VuiTypography></VuiBox>,
                    [monthColumns[6]]:
                        <VuiBox display="flex" alignItems="center" px={0.8} py={0.1}> <VuiTypography variant="button" color="white" fontWeight="medium"> {values[6]} </VuiTypography></VuiBox>,
                    [monthColumns[7]]:
                        <VuiBox display="flex" alignItems="center" px={0.8} py={0.1}> <VuiTypography variant="button" color="white" fontWeight="medium"> {values[7]} </VuiTypography></VuiBox>,
                    [monthColumns[8]]:
                        <VuiBox display="flex" alignItems="center" px={0.8} py={0.1}> <VuiTypography variant="button" color="white" fontWeight="medium"> {values[8]} </VuiTypography></VuiBox>,
                    [monthColumns[9]]:
                        <VuiBox display="flex" alignItems="center" px={0.8} py={0.1}> <VuiTypography variant="button" color="white" fontWeight="medium"> {values[9]} </VuiTypography></VuiBox>,
                    [monthColumns[10]]:
                        <VuiBox display="flex" alignItems="center" px={0.8} py={0.1}> <VuiTypography variant="button" color="white" fontWeight="medium"> {values[10]} </VuiTypography></VuiBox>,
                    [monthColumns[11]]:
                        <VuiBox display="flex" alignItems="center" px={0.8} py={0.1}> <VuiTypography variant="button" color="white" fontWeight="medium"> {values[11]} </VuiTypography></VuiBox>,
                    [monthColumns[12]]:
                        <VuiBox display="flex" alignItems="center" px={0.8} py={0.1}> <VuiTypography variant="button" color="white" fontWeight="medium"> {values[12]} </VuiTypography></VuiBox>
                };

                rows.push(row);

                let chartname = membername;
                if (isGuild)
                    chartname = guildname;
                chartRows.push({
                    name: chartname,
                    data: values
                });
            }

            setResultRows(rows);
            setLineChartData(chartRows);
        }
        catch (error) {
            alert(error);
        }
    }

    function setResultsColumns(guilds) {
        try {
            if (guilds.length > 0) {
                let columns = [];
                let myresultColumnsList = [];
                let guild = guilds[0];

                columns.push({ name: "name", align: "left" });
                columns.push({ name: "guild", align: "left" });

                for (let i2 = 11 - 1; i2 >= 0; i2--) {
                    columns.push({ name: guild.historyDates[i2], align: "left" });
                    myresultColumnsList.push(guild.historyDates[i2]);
                }
                columns.push({ name: 'Now', align: "left" });
                myresultColumnsList.push('Now');

                setResultColumnsList(myresultColumnsList);
                columnList = myresultColumnsList;
                setResultColumns(columns);
            }
        } catch (error) {
            alert(error);
        }
    }

    function setChartOptions(months, colours) {
        let options = {
            chart: {
                toolbar: {
                    show: false,
                },
            },
            tooltip: {
                theme: "dark",
            },
            dataLabels: {
                enabled: false,
            },
            stroke: {
                curve: "smooth",
            },
            xaxis: {
                type: "datetime",
                categories: months,
                labels: {
                    style: {
                        colors: "#c8cfca",
                        fontSize: "10px",
                    },
                },
                axisBorder: {
                    show: false,
                },
                axisTicks: {
                    show: false,
                },
            },
            yaxis: {
                labels: {
                    style: {
                        colors: "#c8cfca",
                        fontSize: "10px",
                    },
                },
            },
            legend: {
                show: false,
            },
            grid: {
                strokeDashArray: 5,
                borderColor: "#56577A",
            },
            fill: {
                type: "gradient",
                gradient: {
                    shade: "dark",
                    type: "vertical",
                    shadeIntensity: 0,
                    gradientToColors: undefined, // optional, if not defined - uses the shades of same color in series
                    inverseColors: true,
                    opacityFrom: 0.8,
                    opacityTo: 0,
                    stops: [],
                },
                colors: colours,
            },
            colors: colours, //["#0075FF", "#2CD9FF"],
        }

        setLineChartOptions(options);
    }

    function setGuildDetails(allGuilds, guild) {
        setGuildName(guild);
        let myGuild = allGuilds.find(g => g.name === guild);
        if (myGuild && myGuild.colour) {
            setGuildColour('#' + myGuild.colour);
        }
    }

    function setMemberDetails(curMember, allGuilds) {

        try {
            setMemberName(curMember.name);
            setGuildDetails(allGuilds, curMember.guild);
            setServerNumber(curMember.server);
            setUserId(curMember.userId);
            setDiscord(curMember.discord);
            setComments(curMember.comments);
            setPower(curMember.power);
            setPreviousPower(curMember.previousPower);
            //setPowerInc(curMember.previousPower);
            setCCL(curMember.ccl);
            setTrans(curMember.trans);
            setSTier(curMember.stier);
            setATier(curMember.atier);
            setTemple(curMember.temple);
            setDestinyValue(curMember.temple);
            setHeroesD6(curMember.d6);
            setHeroesD5(curMember.d5);
            setHeroesD4(curMember.d4);
            setHeroesD3(curMember.d3);
            setHeroesD2(curMember.d2);
            setHeroesD1(curMember.d1);
            setHeroesT5(curMember.t5);
            setHeroesT4(curMember.t4);
            setHeroesT3(curMember.t3);
            setHeroesT2(curMember.t2);
            setHeroesT1(curMember.t1);
            setHeroesV4(curMember.v4);
            setHeroesV3(curMember.v3);
            setHeroesV2(curMember.v2);
            setHeroesV1(curMember.v1);
            setSeScore(curMember.se);
            setSeScoreEasy(curMember.seeasy);
            setExtraSS(curMember.extraSS);            
            //setUpdated(curMember.updated);
            
            setLeaderCheck(false);
            setOfficerCheck(false);
            setAltCheck(false);
            setInactiveCheck(false);

            if (curMember.position)
            {
                if (curMember.position.includes('L'))
                    setLeaderCheck(true);
                if (curMember.position.includes('O'))
                    setOfficerCheck(true);
                if (curMember.position.includes('A'))
                    setAltCheck(true);
                if (curMember.position.includes('I'))
                    setInactiveCheck(true);
            }

            if (curMember.se && curMember.seeasy) {
                let hard = (curMember.se - curMember.seeasy);
                setSeHard(hard.toFixed(1));
            }

            if (curMember.power && curMember.previousPower) {
                let powerPercent = convertStringToNumber(((curMember.power / curMember.previousPower) - 1) * 100, 1);
                let powerInc = (curMember.power - curMember.previousPower);
                if (powerInc) {
                    powerInc = powerInc.toFixed(1);
                    if (powerInc > 0) {
                        setPwrColor('success');
                        powerInc = '+' + powerInc;
                    }
                    else
                        setPwrColor('error');
                }
                powerInc = powerInc + ' (' + powerPercent + '%)';
                setPowerChange(powerInc);
            }

            setTotalSS(calculateSS(curMember).toFixed(1));
        }
        catch(err)
        {
            alert(err)
        }
    }

    function convertStringToNumber(value, dp) {
        if (value) {
            var number = parseFloat(value.toString().replaceAll(",", ""));

            let decimalPlaces = 2;
            if (dp)
                decimalPlaces = dp;

            if (number >= 1000 || number <= -1000)
                return number.toLocaleString();
            else
                return number.toFixed(decimalPlaces);
        }
        else
            return value;
    };

    const getDetails = useCallback(async () => {
        setSaveDisabled(true);
        let guildname = location.state.guildname;
        setGuildName(guildname);
        let membername = location.state.membername;
        setMemberName(membername);
        getUser()
            .then((result) => {
                setUser(result);
                setIsAdmin(result.isAdmin);
                setIsDisabled(!result.isAdmin);

                getAPIToken()
                    .then((token) => {
                        getGuilds(token)
                            .then((guildsResult) => {
                                setGuilds(guildsResult);
                                allGuilds = guildsResult;
                                let myGuild = guildsResult.find(g => g.name === guildname);

                                const tempGuildNames = guildsResult.map((g) => g.name);
                                tempGuildNames.push('Ex-Members');

                                setGuildNames(tempGuildNames)

                                let months = [];
                                let colours = [];

                                // user colour
                                colours.push("#0075FF");

                                if (myGuild) {
                                    colours.push('#' + myGuild.colour);

                                    for (let i2 = myGuild.historyDates.length - 1; i2 >= 0; i2--) {
                                        months.push(myGuild.historyDates[i2]);
                                    }
                                    months.push('Now');
                                }

                                setChartOptions(months, colours);
                                setResultsColumns(guildsResult);

                                getMember(token, guildname, membername)
                                    .then((membersResult) => {
                                        var myMember = {}
                                        if (membersResult && membersResult.length > 0) {
                                            myMember = membersResult[0];
                                            setNewMember(false);
                                        }
                                        else {
                                            myMember.name = null;
                                            myMember.guild = guildname;                                            
                                            myMember.server = null;
                                            myMember.userId = null;
                                            myMember.discord = null;
                                            myMember.comments = null;
                                            myMember.power = null;
                                            myMember.ccl = null;
                                            myMember.trans = null;
                                            myMember.stier = null;
                                            myMember.atier = null;
                                            myMember.temple = null;
                                            myMember.d6 = null;
                                            myMember.d5 = null;
                                            myMember.d4 = null;
                                            myMember.d3 = null;
                                            myMember.d2 = null;
                                            myMember.d1 = null;
                                            myMember.t5 = null;
                                            myMember.t4 = null;
                                            myMember.t3 = null;
                                            myMember.t2 = null;
                                            myMember.t1 = null;
                                            myMember.v4 = null;
                                            myMember.v3 = null;
                                            myMember.v2 = null;
                                            myMember.v1 = null;
                                            myMember.se = null;
                                            myMember.seeasy = null;
                                            myMember.extraSS = null;
                                            setNewMember(true);
                                        }
                                        setMember(myMember);
                                        setMemberDetails(myMember, guildsResult);

                                        let chartItems = [];
                                        chartItems.push(myMember);
                                        if (myGuild)
                                            chartItems.push(myGuild);
                                        setSelectedItems(chartItems);
                                        refreshChart(chartItems, "Power");
                                        setMemberHistoryGrid(allGuilds, myMember)
                                    },
                                        (error) => {
                                            alert(error);
                                        });
                            },
                            (error) => {
                                alert(error);
                                });
                    },
                    (error) => {
                        alert(error);
                    });
            },
            (error) => {
                history.push('/authentication/sign-in');
            });
    }, []);


    useEffect(() => {
        getDetails();
    }, [getDetails]);

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <VuiBox py={3}>

                <VuiBox mb={3}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={6} xl={6}>
                            <Card sx={{ padding: "17px" }} style={{ backgroundColor: guildColour }}>
                                <VuiBox display="flex" justifyContent="space-between" alignItems="center" mb="22px">
                                    <VuiTypography variant="lg" color="white">
                                        {memberName}
                                    </VuiTypography>
                                    <Link to={{ pathname: '/guild', state: { guildname: guildName } }}>
                                        <VuiTypography variant="lg" color="white">
                                            {guildName}
                                        </VuiTypography>
                                    </Link>
                                </VuiBox>
                            </Card>
                        </Grid>
                        <Grid item xs={12} md={6} xl={2}>

                            {isAdmin ? (
                                <Card>
                                    <VuiButton
                                        disabled={saveDisabled}
                                        onClick={handleSaveClick}
                                        color="info"
                                        sx={{ textAlign: "center", fontWeight: "500 !important" }} >
                                        Save Changes
                                    </VuiButton>
                                    <VuiTypography align="center" component="label" variant="button" color={saveMessageColor} fontWeight="medium">
                                        {saveMessage}
                                    </VuiTypography>
                                </Card>
                            ) : (
                                <VuiBox />
                            )}
                        </Grid>
                    </Grid>
                </VuiBox>
                <VuiBox mb={3}>
                    <Grid container spacing="18px">
                        <Grid item xs={12} lg={6} xl={6}>
                            <Card>
                                <VuiBox height="100%" display="flex" flexDirection="column" justifyContent="space-between">
                                    <Grid container spacing="18px">
                                        <Grid item xs={12} lg={6} xl={8}>
                                            <VuiBox>
                                                <VuiBox mb={1} ml={0.5}>
                                                    <VuiTypography component="label" variant="button" color="white" fontWeight="medium">
                                                        Name
                                                    </VuiTypography>
                                                    <VuiInput
                                                            onChange={e => updateMemberName(e.target.value)}
                                                            type="text"
                                                            disabled={isDisabled}
                                                    value={memberName}
                                                    />
                                                </VuiBox>
                                            </VuiBox>
                                            <VuiBox>
                                                {isAdmin ? (
                                                    <VuiBox mb={1} ml={0.5}>
                                                            <VuiTypography component="label" variant="button" color="white" fontWeight="medium">
                                                               Discord
                                                            </VuiTypography>
                                                        <VuiInput
                                                            onChange={e => updateDiscord(e.target.value)}
                                                            type="text"
                                                            value={discord}
                                                        />
                                                    </VuiBox>
                                                ) : (
                                                    <VuiBox mb={1} ml={0.5}>
                                                    </VuiBox>
                                                )}
                                            </VuiBox>
                                            <VuiBox>
                                                <VuiBox mb={1} ml={0.5}>
                                                    <VuiTypography component="label" variant="button" color="white" fontWeight="medium">
                                                        Guild
                                                    </VuiTypography>
                                                    {isAdmin ? (
                                                        <VuiBox display="flex" justifyContent="space-between" alignItems="center" mb="0px">
                                                            <VuiInput
                                                                type="text"
                                                                value={guildName}
                                                                bgColor={guildColour}
                                                                disabled="true"
                                                            />
                                                            <Icon sx={{ cursor: "pointer", fontWeight: "bold", color: "#ffffff" }} fontSize="small" onClick={openMenuGuild}>
                                                                arrow_drop_down
                                                            </Icon>
                                                            {renderMenuGuild}

                                                        </VuiBox>
                                                    ) : (
                                                        <VuiInput
                                                            type="text"
                                                            value={guildName}
                                                            bgColor={guildColour}
                                                            disabled="true"
                                                        />
                                                    )}
                                                </VuiBox>
                                            </VuiBox>
                                        </Grid>
                                        <Grid item xs={12} lg={6} xl={4}>
                                            <VuiBox>
                                                <VuiBox mb={1} ml={0.5}>
                                                    <VuiTypography component="label" variant="button" color="white" fontWeight="medium">
                                                        Server
                                                    </VuiTypography>
                                                    <VuiInput
                                                        onChange={e => updateServer(e.target.value)}
                                                            type="number"
                                                            disabled={isDisabled}
                                                        value={serverNumber}
                                                    />
                                                </VuiBox>
                                            </VuiBox>
                                            <VuiBox>
                                                <VuiBox mb={1} ml={0.5}>
                                                    {isAdmin ? (
                                                        <VuiTypography component="label" variant="button" color="white" fontWeight="medium">
                                                            User Id
                                                        </VuiTypography>
                                                    ) : (
                                                        <VuiBox mb={1} ml={0.5}>
                                                        </VuiBox>
                                                    )}
                                                {isAdmin ? (
                                                        <VuiInput
                                                            onChange={e => updateUserId(e.target.value)}
                                                        type="text"
                                                        value={userId}
                                                    />
                                                ) : (
                                                        <VuiBox mb={1} ml={0.5}>
                                                        </VuiBox>
                                                    )}
                                                </VuiBox>
                                            </VuiBox>
                                            <VuiBox>
                                                <VuiBox mb={1} ml={1}>
                                                    <Grid container spacing="0px">
                                                        <Grid item xs={12} lg={6} xl={6}>
                                                                <VuiSwitch color="info" checked={leaderCheck} onChange={handleLeaderCheck} />
                                                                <VuiTypography
                                                                    variant="caption"
                                                                    color="white"
                                                                    fontWeight="medium"
                                                                    onClick={handleLeaderCheck}
                                                                    disabled={isDisabled}
                                                                    sx={{ cursor: "pointer", userSelect: "none" }}
                                                                >
                                                                    &nbsp;&nbsp;&nbsp;&nbsp;Leader
                                                                    </VuiTypography>
                                                        </Grid>
                                                        <Grid item xs={12} lg={6} xl={6}>
                                                                <VuiSwitch color="info" checked={officerCheck} onChange={handleOfficerCheck} />
                                                                <VuiTypography
                                                                    variant="caption"
                                                                    color="white"
                                                                    fontWeight="medium"
                                                                    onClick={handleOfficerCheck}
                                                                    disabled={isDisabled}
                                                                    sx={{ cursor: "pointer", userSelect: "none" }}
                                                                >
                                                                    &nbsp;&nbsp;&nbsp;&nbsp;Officer
                                                                    </VuiTypography>
                                                        </Grid>
                                                        <Grid item xs={12} lg={6} xl={6}>
                                                                <VuiSwitch color="info" checked={altCheck} onChange={handleAltCheck} />
                                                                <VuiTypography
                                                                    variant="caption"
                                                                    color="white"
                                                                    fontWeight="medium"
                                                                    onClick={handleAltCheck}
                                                                    disabled={isDisabled}
                                                                    sx={{ cursor: "pointer", userSelect: "none" }}
                                                                >
                                                                    &nbsp;&nbsp;&nbsp;&nbsp;Alt
                                                                    </VuiTypography>
                                                        </Grid>
                                                        <Grid item xs={12} lg={6} xl={6}>
                                                                <VuiSwitch color="info" checked={inactiveCheck} onChange={handleInactiveCheck} />
                                                                <VuiTypography
                                                                    variant="caption"
                                                                    color="white"
                                                                    fontWeight="medium"
                                                                    onClick={handleInactiveCheck}
                                                                    disabled={isDisabled}
                                                                    sx={{ cursor: "pointer", userSelect: "none" }}
                                                                >
                                                                    &nbsp;&nbsp;&nbsp;&nbsp;Inactive
                                                                    </VuiTypography>
                                                        </Grid>
                                                    </Grid>
                                                </VuiBox>
                                            </VuiBox>
                                        </Grid>
                                        <Grid item xs={12} lg={6} xl={4}>
                                            <VuiBox>
                                                <VuiBox mb={1} ml={0.5}>
                                                    <VuiTypography component="label" variant="button" color="white" fontWeight="medium">
                                                        Power
                                                    </VuiTypography>
                                                    <VuiInput
                                                        onChange={e => updatePower(e.target.value)}
                                                        type="number"
                                                        disabled={isDisabled}
                                                        value={power}
                                                    />
                                                </VuiBox>
                                            </VuiBox>
                                        </Grid>
                                        <Grid item xs={12} lg={6} xl={4}>
                                            <VuiBox>
                                                <VuiBox mb={1} ml={0.5}>
                                                    <VuiBox>
                                                    <VuiTypography component="label" variant="button" color="white" fontWeight="medium">
                                                        Previous Power
                                                    </VuiTypography>
                                                    </VuiBox>
                                                    <VuiBox>
                                                        <VuiTypography component="label" variant="button" color="white" fontWeight="medium">
                                                                {previousPower}
                                                        </VuiTypography>
                                                        <VuiTypography component="label" variant="button" color={pwrColor} fontWeight="medium">
                                                            &nbsp;&nbsp;{powerChange}
                                                        </VuiTypography>
                                                    </VuiBox>
                                                </VuiBox>
                                            </VuiBox>
                                        </Grid>
                                        <Grid item xs={12} lg={6} xl={4}>
                                            <VuiBox>
                                                <VuiBox mb={1} ml={0.5}>
                                                    <VuiTypography component="label" variant="button" color="white" fontWeight="medium">
                                                        CCL
                                                    </VuiTypography>
                                                    <VuiInput
                                                        onChange={e => updateCCL(e.target.value)}
                                                        type="number"
                                                        disabled={isDisabled}
                                                        value={ccl}
                                                    />
                                                </VuiBox>
                                            </VuiBox>
                                        </Grid>
                                        <Grid item xs={12} lg={6} xl={4}>
                                            <VuiBox>
                                                <VuiBox mb={1} ml={0.5}>
                                                    <VuiTypography component="label" variant="button" color="white" fontWeight="medium">
                                                        Star Expedition Total
                                                    </VuiTypography>
                                                    <VuiInput
                                                        onChange={e => updateSeScore(e.target.value)}
                                                        type="number"
                                                        disabled={isDisabled}
                                                        value={seScore}
                                                    />
                                                </VuiBox>
                                            </VuiBox>
                                        </Grid>
                                        <Grid item xs={12} lg={6} xl={4}>
                                            <VuiBox>
                                                <VuiBox mb={1} ml={0.5}>
                                                    <VuiTypography component="label" variant="button" color="white" fontWeight="medium">
                                                        Star Expedition Easy
                                                    </VuiTypography>
                                                    <VuiInput
                                                        onChange={e => updateSeScoreEasy(e.target.value)}
                                                        type="number"
                                                        disabled={isDisabled}
                                                        value={seScoreEasy}
                                                    />
                                                </VuiBox>
                                            </VuiBox>
                                        </Grid>
                                        <Grid item xs={12} lg={6} xl={4}>
                                            <VuiBox>
                                                <VuiBox mb={1} ml={0.5}>
                                                    <VuiBox>
                                                        <VuiTypography component="label" variant="button" color="white" fontWeight="medium">
                                                            Star Expedition Hard
                                                        </VuiTypography>
                                                    </VuiBox>
                                                    <VuiBox>
                                                        <VuiTypography component="label" variant="button" color="white" fontWeight="medium">
                                                            {seHard}
                                                        </VuiTypography>
                                                    </VuiBox>
                                                </VuiBox>
                                            </VuiBox>
                                        </Grid>
                                    </Grid>
                                </VuiBox>
                            </Card>
                        </Grid>

                        <Grid item xs={12} lg={6} xl={6}>
                            <Card>
                                <VuiBox height="100%" display="flex" flexDirection="column" justifyContent="space-between">
                                    <VuiBox>
                                        <VuiBox mb={1} ml={0.5}>
                                            <VuiTypography component="label" variant="button" color="white" fontWeight="medium">
                                                Heroes
                                            </VuiTypography>


                                            <Grid container spacing="18px">
                                                <Grid item xs={12} lg={6} xl={4}>
                                                    <VuiBox mb={1} ml={0.5}>
                                                        <Grid style={{ display: "flex" }}>
                                                            <img src={imgSTier} alt="logo" width="40" height="40" />
                                                            &nbsp;&nbsp;
                                                            <VuiInput onChange={e => updateSTier(e.target.value)} type="number" disabled={isDisabled} value={stier} />
                                                        </Grid>
                                                    </VuiBox>
                                                </Grid>
                                                <Grid item xs={12} lg={6} xl={4}>
                                                    <VuiBox mb={1} ml={0.5}>
                                                        <Grid style={{ display: "flex" }}>
                                                            <img src={imgATier} alt="logo" width="40" height="40" />
                                                            &nbsp;&nbsp;
                                                            <VuiInput onChange={e => updateATier(e.target.value)} type="number" disabled={isDisabled} value={atier} />
                                                        </Grid>
                                                    </VuiBox>
                                                </Grid>
                                                <Grid item xs={12} lg={6} xl={4}>
                                                    <VuiBox mb={1} ml={0.5}>
                                                        <Grid style={{ display: "flex" }}>
                                                            <img src={imgTrans} alt="logo" width="40" height="40" />
                                                            &nbsp;&nbsp;
                                                            <VuiInput onChange={e => updateTrans(e.target.value)} type="number" disabled={isDisabled} value={trans} />
                                                        </Grid>
                                                    </VuiBox>
                                                </Grid>
                                                <Grid item xs={12} lg={6} xl={4}>
                                                    <VuiBox mb={1} ml={0.5}>
                                                        <Grid style={{ display: "flex" }}>
                                                            <img src={imgTemple} alt="logo" width="40" height="40" />
                                                            &nbsp;&nbsp;
                                                            <VuiInput onChange={e => updateTemple(e.target.value)} type="number" disabled={isDisabled} value={temple} />
                                                        </Grid>
                                                    </VuiBox>
                                                </Grid>
                                                <Grid item xs={12} lg={6} xl={4}>
                                                    <VuiBox mb={1} ml={0.5}>
                                                    </VuiBox>
                                                </Grid>
                                                <Grid item xs={12} lg={6} xl={4}>
                                                    <VuiBox mb={1} ml={0.5}>
                                                    </VuiBox>
                                                </Grid>
                                                <Grid item xs={12} lg={6} xl={4}>
                                                    <Grid item xs={12} lg={6} xl={12}>
                                                        <VuiBox mb={1} ml={0.5}>
                                                            <Grid style={{ display: "flex" }}>
                                                                <img src={imgD6} alt="logo" width="40" height="40" />
                                                                <VuiTypography color="white" fontWeight="bold" verticalAlign="middle" variant="h3" textGradient>
                                                                    &nbsp;&nbsp;{heroesD6Value}
                                                                </VuiTypography> 
                                                                &nbsp;&nbsp;
                                                                <VuiInput onChange={e => updateHeroesD6(e.target.value)} type="number" disabled={isDisabled} value={heroesD6} />
                                                            </Grid>
                                                        </VuiBox>
                                                        <VuiBox mb={1} ml={0.5}>
                                                            <Grid style={{ display: "flex" }}>
                                                                <img src={imgD5} alt="logo" width="40" height="40" />
                                                                <VuiTypography color="white" fontWeight="bold" verticalAlign="middle" variant="h3" textGradient>
                                                                    &nbsp;&nbsp;{heroesD5Value}
                                                                </VuiTypography> 
                                                                &nbsp;&nbsp;
                                                                <VuiInput onChange={e => updateHeroesD5(e.target.value)} type="number" disabled={isDisabled} value={heroesD5} />
                                                            </Grid>
                                                        </VuiBox>
                                                        <VuiBox mb={1} ml={0.5}>
                                                            <Grid style={{ display: "flex" }}>
                                                                <img src={imgD4} alt="logo" width="40" height="40" />
                                                                <VuiTypography color="white" fontWeight="bold" verticalAlign="middle" variant="h3" textGradient>
                                                                    &nbsp;&nbsp;{heroesD4Value}
                                                                </VuiTypography> 
                                                                &nbsp;&nbsp;
                                                                <VuiInput onChange={e => updateHeroesD4(e.target.value)} type="number" disabled={isDisabled} value={heroesD4} />
                                                            </Grid>
                                                        </VuiBox>
                                                        <VuiBox mb={1} ml={0.5}>
                                                            <Grid style={{ display: "flex" }}>
                                                                <img src={imgD3} alt="logo" width="40" height="40" />                                                                
                                                                <VuiTypography color="white" fontWeight="bold" verticalAlign="middle" variant="h3" textGradient>
                                                                    &nbsp;&nbsp;{heroesD3Value}
                                                                </VuiTypography> 
                                                                &nbsp;&nbsp;
                                                                <VuiInput onChange={e => updateHeroesD3(e.target.value)} type="number" disabled={isDisabled} value={heroesD3} />
                                                            </Grid>
                                                        </VuiBox>
                                                        <VuiBox mb={1} ml={0.5}>
                                                            <Grid style={{ display: "flex" }}>
                                                                <img src={imgD2} alt="logo" width="40" height="40" />
                                                                <VuiTypography color="white" fontWeight="bold" verticalAlign="middle" variant="h3" textGradient>
                                                                    &nbsp;&nbsp;{heroesD2Value}
                                                                </VuiTypography> 
                                                                &nbsp;&nbsp;
                                                                <VuiInput onChange={e => updateHeroesD2(e.target.value)} type="number" disabled={isDisabled} value={heroesD2} />
                                                            </Grid>
                                                        </VuiBox>
                                                        <VuiBox mb={1} ml={0.5}>
                                                            <Grid style={{ display: "flex" }}>
                                                                <img src={imgD1} alt="logo" width="40" height="40" />                                                                
                                                                <VuiTypography color="white" fontWeight="bold" verticalAlign="middle" variant="h3" textGradient>
                                                                    &nbsp;&nbsp;{heroesD1Value}
                                                                </VuiTypography> 
                                                                &nbsp;&nbsp;
                                                                <VuiInput onChange={e => updateHeroesD1(e.target.value)} type="number" disabled={isDisabled} value={heroesD1} />
                                                            </Grid>
                                                        </VuiBox>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={12} lg={6} xl={4}>
                                                    <Grid item xs={12} lg={6} xl={12}>
                                                        <VuiBox mb={1} ml={0.5}>
                                                            <Grid style={{ display: "flex" }}>
                                                                <img src={imgT5} alt="logo" width="40" height="40" />
                                                                &nbsp;&nbsp;
                                                                <VuiInput onChange={e => updateHeroesT5(e.target.value)} type="number" disabled={isDisabled} value={heroesT5} />
                                                            </Grid>
                                                        </VuiBox>
                                                        <VuiBox mb={1} ml={0.5}>
                                                            <Grid style={{ display: "flex" }}>
                                                                <img src={imgT4} alt="logo" width="40" height="40" />
                                                                &nbsp;&nbsp;
                                                                <VuiInput onChange={e => updateHeroesT4(e.target.value)} type="number" disabled={isDisabled} value={heroesT4} />
                                                            </Grid>
                                                        </VuiBox>
                                                        <VuiBox mb={1} ml={0.5}>
                                                            <Grid style={{ display: "flex" }}>
                                                                <img src={imgT3} alt="logo" width="40" height="40" />
                                                                &nbsp;&nbsp;
                                                                <VuiInput onChange={e => updateHeroesT3(e.target.value)} type="number" disabled={isDisabled} value={heroesT3} />
                                                            </Grid>
                                                        </VuiBox>
                                                        <VuiBox mb={1} ml={0.5}>
                                                            <Grid style={{ display: "flex" }}>
                                                                <img src={imgT2} alt="logo" width="40" height="40" />
                                                                &nbsp;&nbsp;
                                                                <VuiInput onChange={e => updateHeroesT2(e.target.value)} type="number" disabled={isDisabled} value={heroesT2} />
                                                            </Grid>
                                                        </VuiBox>
                                                        <VuiBox mb={1} ml={0.5}>
                                                            <Grid style={{ display: "flex" }}>
                                                                <img src={imgT1} alt="logo" width="40" height="40" />
                                                                &nbsp;&nbsp;
                                                                <VuiInput onChange={e => updateHeroesT1(e.target.value)} type="number" disabled={isDisabled} value={heroesT1} />
                                                            </Grid>
                                                        </VuiBox>
                                                    </Grid>
                                                </Grid>

                                                <Grid item xs={12} lg={6} xl={4}>
                                                    <Grid item xs={12} lg={6} xl={12}>
                                                        <VuiBox mb={1} ml={0.5}>
                                                            <Grid style={{ display: "flex" }}>
                                                                <img src={imgV4} alt="logo" width="40" height="40" />
                                                                &nbsp;&nbsp;
                                                                <VuiInput onChange={e => updateHeroesV4(e.target.value)} type="number" disabled={isDisabled} value={heroesV4} />
                                                            </Grid>
                                                        </VuiBox>
                                                        <VuiBox mb={1} ml={0.5}>
                                                            <Grid style={{ display: "flex" }}>
                                                                <img src={imgV3} alt="logo" width="40" height="40" />
                                                                &nbsp;&nbsp;
                                                                <VuiInput onChange={e => updateHeroesV3(e.target.value)} type="number" disabled={isDisabled} value={heroesV3} />
                                                            </Grid>
                                                        </VuiBox>
                                                        <VuiBox mb={1} ml={0.5}>
                                                            <Grid style={{ display: "flex" }}>
                                                                <img src={imgV2} alt="logo" width="40" height="40" />
                                                                &nbsp;&nbsp;
                                                                <VuiInput onChange={e => updateHeroesV2(e.target.value)} type="number" disabled={isDisabled} value={heroesV2} />
                                                            </Grid>
                                                        </VuiBox>
                                                        <VuiBox mb={1} ml={0.5}>
                                                            <Grid style={{ display: "flex" }}>
                                                                <img src={imgV1} alt="logo" width="40" height="40" />
                                                                &nbsp;&nbsp;
                                                                <VuiInput onChange={e => updateHeroesV1(e.target.value)} type="number" disabled={isDisabled} value={heroesV1} />
                                                            </Grid>
                                                        </VuiBox>
                                                        <VuiBox mb={1} ml={0.5}>
                                                            <Grid style={{ display: "flex" }}>
                                                            </Grid>
                                                        </VuiBox>
                                                        <VuiBox mb={1} ml={0.5}>
                                                        <VuiTypography component="label" variant="button" color="white" fontWeight="medium">
                                                            &nbsp;Additional Stellar (in millions)
                                                            </VuiTypography>
                                                            <Grid style={{ display: "flex" }}>
                                                                <img src={imgStellar} alt="logo" width="40" height="40" />
                                                                &nbsp;&nbsp;
                                                                <VuiInput onChange={e => updateExtraSS(e.target.value)} type="number" disabled={isDisabled} value={extraSS} />
                                                            </Grid>
                                                        </VuiBox>
                                                    </Grid>
                                                </Grid>
                                            </Grid>

                                            <VuiBox>
                                                <VuiBox mb={1} ml={0.5}>
                                                    <VuiBox>
                                                        <VuiTypography component="label" variant="button" color="white" fontWeight="medium">
                                                            Total Stellar Shards : &nbsp; &nbsp;
                                                            </VuiTypography>
                                                        <VuiTypography component="label" variant="button" color="white" fontWeight="medium">
                                                            {totalSS}
                                                         </VuiTypography>
                                                    </VuiBox>
                                                </VuiBox>
                                            </VuiBox>
                                        </VuiBox>
                                    </VuiBox>
                                </VuiBox>
                            </Card>
                        </Grid>

                        {isAdmin ? (
                        <Grid item xs={12} lg={6} xl={12}>
                            <Card>
                                <VuiBox height="100%" display="flex" flexDirection="column" justifyContent="space-between">
                                    <VuiBox>
                                        <VuiBox mb={1} ml={0.5}>
                                            <VuiTypography component="label" variant="button" color="white" fontWeight="medium">
                                                Comments
                                            </VuiTypography>
                                                <VuiInput
                                                    onChange={e => updateComments(e.target.value)}
                                                    type="text"
                                                    multiline="true"
                                                    value={comments}
                                                />
                                        </VuiBox>
                                    </VuiBox>
                                </VuiBox>
                            </Card>
                            </Grid>

                        ) : (
                            <Grid item xs={12} lg={6} xl={12}>
                            </Grid>
                         )}
                    </Grid>
                </VuiBox>
                <VuiBox mb={3}>
                    <Card>
                        <VuiBox height="100%" display="flex" flexDirection="column" justifyContent="space-between">
                            <VuiBox>
                                <VuiBox display="flex" justifyContent="space-between" alignItems="center" mb="0px">
                                    <VuiTypography variant="lg" color="white">
                                        Comparison by {sortMode}
                                    </VuiTypography>

                                    <VuiBox>
                                        <Icon sx={{ cursor: "pointer", color: "#ffffff" }} fontSize="small" onClick={openMenu}>
                                            show_chart
                                        </Icon>
                                        <Icon sx={{ cursor: "pointer", color: "#ffffff" }} fontSize="small" onClick={openMenu}>
                                            arrow_drop_down
                                        </Icon>
                                        {renderMenu}
                                    </VuiBox>
                                </VuiBox>
                                <VuiBox
                                    sx={{
                                        "& th": {
                                            borderBottom: ({ borders: { borderWidth }, palette: { grey } }) =>
                                                `${borderWidth[1]} solid ${grey[700]}`,
                                        },
                                        "& .MuiTableRow-root:not(:last-child)": {
                                            "& td": {
                                                borderBottom: ({
                                                    borders: { borderWidth }, palette: { grey } }) =>
                                                    `${borderWidth[1]} solid ${grey[700]}`,
                                            },
                                        },
                                    }}
                                >
                                    <Table columns={resultColumns} rows={resultRows} />
                                </VuiBox>
                                <VuiBox sx={{ height: "510px" }}>
                                    <LineChart
                                        lineChartData={lineChartData}
                                        lineChartOptions={lineChartOptions}
                                    />
                                </VuiBox>
                            </VuiBox>
                        </VuiBox>
                    </Card>
                </VuiBox>
                
                <VuiBox mb={3}>
                    <Card>
                        <VuiBox display="flex" justifyContent="space-between" alignItems="center" mb="0px">
                            <VuiBox height="100%" display="flex" flexDirection="column" justifyContent="space-between">
                                <VuiTypography variant="lg" color="white">
                                    History
                                </VuiTypography>
                            </VuiBox>
                            </VuiBox>
                                    <VuiBox>
                            <VuiBox
                                    sx={{
                                        "& th": {
                                            borderBottom: ({ borders: { borderWidth }, palette: { grey } }) =>
                                                `${borderWidth[1]} solid ${grey[700]}`,
                                        },
                                        "& .MuiTableRow-root:not(:last-child)": {
                                            "& td": {
                                                borderBottom: ({
                                                    borders: { borderWidth }, palette: { grey } }) =>
                                                    `${borderWidth[1]} solid ${grey[700]}`,
                                            },
                                        },
                                    }}
                                >
                                    <Table columns={historyColumns} rows={historyRows} />
                            </VuiBox>
                        </VuiBox>
                    </Card>
                </VuiBox>
            </VuiBox>
            <Footer />
        </DashboardLayout>
    );
}

export default Member;
